import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
// import Amplify from 'aws-amplify';
import React from 'react';
import './App.css';
// import awsconfig from './aws-exports';
import Footer from './Footer';
import Header from './Header';
import theme from './modules/theme';
import Routes from './Routes';

// Amplify.configure(awsconfig);

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Header />
        <Routes />
        <Footer />
      </ThemeProvider>
    </>
  );
}

export default App;
